<template>
  <div class="print-description-wrapper">
    <div class="total-title">温馨提示</div>
    <div class="title">请您知悉：</div>
    <section v-if="content">
      <div v-html="content"></div>
    </section>
    <section v-if="flag && !content">
      <p>
        1. 年假&司龄：不影响员工年假、司龄的使用和累计。
        <br />2.
        其他激励与权益：不管员工何时转签及转签到哪个公司，均不影响其他激励与权益。
        <br />3.
        财务报销：财务报销的发票抬头自转签合同生效之日起按照新合同实体名称报销。
        <br />4.
        转签期限：新劳动合同的开始时间为转签生效1日，终止时间与原合同一致,不因本次变更而延长或缩短。
        <br />5.
        社会保险：同城市内部实体转签，不影响连续缴纳的记录，也不会影响近9个月有报销生育保险需求的人员。
        <br />6.
        住房公积金：租房支取公积金、无租房支取公积金、已完成住房公积金批贷且已支取住房公积金的人员，不产生影响。
        <br />7.
        异地安置：如办理过异地安置就医，更换新的实体后，需联系FESCO重新办理异地安置手续。
      </p>
      <div class="title underline">北京实体转北京实体注意</div>
      <p>
        •
        关于工作居住证：已经有工作居住证的同事，可直接操作工作居住证变更到新实体，不会产生影响。只需在转签新实体后，
        需及时进行工作居住证的工作单位变更手续（请联系FESCO相关同事，
        <a
          href="mailto:fesco3@360.cn"
        >fesco3@360.cn</a>）， 如果逾期60天未办理，工作居住证将自然失效。
      </p>
      <div class="title underline">北京实体转天津实体注意</div>
      <p>
        •
        如果期望北京落户（如北京积分落户等），个税或社保转至天津，将失去北京集团内主体的排队资格。
        <br />• 北京工作居住证无法办理、现有持证也会失效，
        <strong>持有工作居住证的员工无法进行聘用单位变更手续，且无法进行续签。</strong>
      </p>
      <div class="title">以下情形可暂缓转签，待情形消失后方可转签：</div>
      <p>
        1.
        <strong>正在办理住房公积金批贷：</strong>实体转签会导致住房公积金封存两个月，已经开始申请公积金贷款的人员将不会获得贷款审批（可暂缓转签）。
        <br />2.
        <strong>刚刚申请办理住房公积支取，未收到第一次到账：</strong>
        实体转签会导致审批过程中出现提交材料信息与实际信息不符，将审批不通过（可暂缓转签）。
        <br />3.
        <strong>正在办理工作居住证：</strong>正在办理工作居住证新办、续签、变更的人员，或工作居住证自转签之日起60天之内到期的，现在进行实体转签将无法通过审批（可暂缓转签）。
        <br />4.
        <strong>正在申报生育津贴与生育报销：</strong>正在申报生育津贴、生育报销的人员，现在进行实体转签将无法进行报销。
        <br />5.
        <strong>正在办理北京落户：</strong>正在办理北京落户，如积分落户、人才引进落户等（可暂缓转签）。
      </p>
    </section>
  </div>
</template>
<script>
import { signNote } from "@/api/pdfH5";
export default {
  data() {
    return {
      content: "",
      flag: false
    };
  },
  created() {
    this.getNote();
  },
  methods: {
    // 获取内容
    getNote() {
      signNote().then(
        ({ data }) => {
          if (data.code === 200 && data.message) {
            this.content = data.message.replace(/\n/g, "<br>");
          } else {
            this.flag = true;
          }
        },
        () => {
          this.flag = true;
        }
      );
    }
  }
};
</script>
<style lang="scss" scoped>
.print-description-wrapper {
  min-height: 100vh;
  padding: 15px;
  background: #fff;
  font-size: 14px;
  img {
    width: 100%;
  }
  .underline {
    text-decoration: underline;
  }
  .title {
    font-size: 16px;
    font-weight: bold;
  }
  p {
    margin: 1em 0;
  }
  .sub-title {
    font-weight: bold;
  }
  .total-title {
    font-weight: bold;
    font-size: 20px;
    text-align: center;
    padding: 1em 0;
  }
  .inline-img {
    display: inline;
    vertical-align: middle;
    width: 30px;
  }
  .red {
    color: red;
  }
  .twoem {
    /* text-indent: 2em; */
    margin-left: 1em;
  }
  .weight {
    font-weight: bold;
  }
  a {
    color: $link-a;
  }
}
</style>
